import { render, staticRenderFns } from "./PopUpEdicionIndicadorManual.vue?vue&type=template&id=d87b5368&scoped=true"
import script from "./PopUpEdicionIndicadorManual.vue?vue&type=script&lang=js"
export * from "./PopUpEdicionIndicadorManual.vue?vue&type=script&lang=js"
import style0 from "./PopUpEdicionIndicadorManual.vue?vue&type=style&index=0&id=d87b5368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87b5368",
  null
  
)

export default component.exports